import { getLocalizedMeta } from '@/utils/common'

const Layout = () => import('@/layout/index.vue')

export default {
  name: 'NoteKit',
  path: '/:language?/notekit',
  component: Layout,
  redirect: '/notekit/detail',
  children: [
    {
      name: 'notekitIndex',
      path: 'detail',
      component: () => import('@/views/NoteKit/Index.vue'),
      meta: {
        hideTab: false,
        menu: 'notekitDetail',
        image: '',
        ...getLocalizedMeta('detailNoteKit')
      }
    }
  ]
}
